import { useRouteMatch } from 'react-router';
import { Subject } from '../types/Subject';

const useAdvisoryReportCreationParams = () => {
  const params = useRouteMatch<{
    subject: Subject;
    reportId: string;
  }>(`/advisory-report/new/:subject/:reportId`);
  return {
    subject: params?.params.subject || '',
    reportId: params?.params.reportId || '',
  };
};

export default useAdvisoryReportCreationParams;
